import type { Report } from '@app/application/client_meetings/types'
import SFetch from '@app/utils/sfetch'

export async function add(reportTemplateId: number): Promise<Report | null> {
  const route = window.Silverfin.Routes.client_meetings_report_templates_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId
  )

  return SFetch.json(route, {
    method: 'POST',
    body: { reportTemplateId },
  })
}

export async function remove(meetingReportId: number): Promise<void> {
  const route = window.Silverfin.Routes.client_meetings_report_template_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    meetingReportId
  )

  await SFetch.raw(route, {
    method: 'DELETE',
  })
}
